var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 257,
    height: 257,
    viewBox: "0 0 257 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M213.128 73.7874V226.256C213.128 229.064 212.012 231.757 210.027 233.743C208.041 235.728 205.348 236.844 202.54 236.844H54.3068C51.4987 236.844 48.8056 235.728 46.8199 233.743C44.8343 231.757 43.7188 229.064 43.7188 226.256V30.5881C43.7188 27.7799 44.8343 25.0868 46.8199 23.1012C48.8056 21.1155 51.4987 20 54.3068 20H159.341L213.128 73.7874Z",
    fill: "#DDDDDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M213.126 73.7705H159.355V20L213.126 73.7705Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.0109 132.022H171.255C173.469 132.022 175.266 130.225 175.266 128.011C175.266 125.797 173.469 124 171.255 124H79.0109C76.7971 124 75 125.797 75 128.011C75 130.225 76.7971 132.022 79.0109 132.022Z",
    fill: "#BBBBBB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.0109 86.0219H131.149C133.362 86.0219 135.159 84.2248 135.159 82.0109C135.159 79.7971 133.362 78 131.149 78H79.0109C76.7971 78 75 79.7971 75 82.0109C75 84.2248 76.7971 86.0219 79.0109 86.0219Z",
    fill: "#BBBBBB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.0109 109.022H171.255C173.469 109.022 175.266 107.225 175.266 105.011C175.266 102.797 173.469 101 171.255 101H79.0109C76.7971 101 75 102.797 75 105.011C75 107.225 76.7971 109.022 79.0109 109.022Z",
    fill: "#BBBBBB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.0109 155.022H171.255C173.469 155.022 175.266 153.225 175.266 151.011C175.266 148.797 173.469 147 171.255 147H79.0109C76.7971 147 75 148.797 75 151.011C75 153.225 76.7971 155.022 79.0109 155.022Z",
    fill: "#BBBBBB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.0109 178.022H171.255C173.469 178.022 175.266 176.225 175.266 174.011C175.266 171.797 173.469 170 171.255 170H79.0109C76.7971 170 75 171.797 75 174.011C75 176.225 76.7971 178.022 79.0109 178.022Z",
    fill: "#BBBBBB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.0109 201.022H171.255C173.469 201.022 175.266 199.225 175.266 197.011C175.266 194.797 173.469 193 171.255 193H79.0109C76.7971 193 75 194.797 75 197.011C75 199.225 76.7971 201.022 79.0109 201.022Z",
    fill: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultFile);
export default __webpack_public_path__ + "static/media/default_file.4a5c7a90f0fd3a87568f5e8b118b7547.svg";
export { ForwardRef as ReactComponent };